import React, { useState, useEffect } from "react";
import SignInPage from "./app/pages/auth/SignInPage";
import { auth } from "./firebase";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./app/components/Header";
import LocaleContextComponent from "./app/providers/LocaleContextComponent";
import { ErrorBoundary } from "react-error-boundary";
import Fallback from "./app/components/Fallback";
import LoadingProgress from "./app/components/LoadingProgress";
import Submissions from "./app/pages/home/Submissions/Submissions";
import Deliveries from "./app/pages/home/Deliveries/Deliveries";
import DeliveryScreen from "./app/pages/home/DeliveryScreen/DeliveryScreen";
import Profile from "./app/pages/home/Profile/Profile";
import UserProfile from './app/pages/home/UserProfile';
import Payments from "./app/pages/home/Payments";
import ArchivedDeliveries from "./app/pages/home/ArchivedDeliveries/ArchivedDeliveries";
import ArchDeliveryScreen from "./app/pages/home/ArchDeliveryScreen/ArchDeliveryScreen";
import Edit from "./app/pages/home/Edit";
import Search from "./app/pages/home/Search";
import Privacy from "./app/pages/Legal/Privacy";
import Terms from "./app/pages/Legal/Terms/Terms";
import DeleteData from "./app/pages/Legal/DeleteData";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    document.title = "Variant admin"
    setLoading(true);
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        const user = {
          uid: userAuth.uid
        };
        setUser(user);
        setLoading(false);
      } else {
        setUser(null);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div>
        <LoadingProgress />
      </div>
    );
  }

  return (
    <>
      {!user && <Router>
        <Switch>
          <Route exact path={["/terms"]}>
            <Terms />
          </Route>
          <Route exact path={["/privacy"]}>
            <Privacy />
          </Route>
          <Route exact path={["/deletedata"]}>
            <DeleteData />
          </Route>
          <Route path={["/"]}>
            <SignInPage />
          </Route>
        </Switch>
      </Router>}
      {user && <LocaleContextComponent >
        <Router>
          <ErrorBoundary FallbackComponent={Fallback} onError={(error, errorInfo) => {
            console.log(error);
            console.log(errorInfo);
          }}>
            <Switch>
              {/* <Route exact path={["/refunds", "/"]}>
                <Header />
                <Refunds />
              </Route> */}
              <Route exact path={["/profile"]}>
                <Profile />
              </Route>
              <Route exact path={["/submissions"]}>
                <Header />
                <Submissions />
              </Route>
              <Route exact path="/deliveries/:order_number">
                <Header />
                <DeliveryScreen />
              </Route>
              <Route exact path="/arch-delivery/:order_number">
                <Header />
                <ArchDeliveryScreen />
              </Route>
              <Route exact path="/p/:uid">
                <Header />
                <UserProfile />
              </Route>
              <Route exact path={["/pay/:type", "/pay/:type/:page", "/pay"]}>
                <Header />
                <Payments />
              </Route>
              <Route exact path="/deliveries">
                <Header />
                <Deliveries />
              </Route>
              <Route exact path={["/arch-deliveries", "/arch-deliveries/:page"]}>
                <Header />
                <ArchivedDeliveries />
              </Route>
              <Route exact path={["/edit/:collection/:pid"]}>
                <Header />
                <Edit />
              </Route>
              <Route exact path={["/search", "/"]}>
                <Header />
                <Search />
              </Route>
              <Route exact path={["/terms"]}>
                <Terms />
              </Route>
              <Route exact path={["/privacy"]}>
                <Privacy />
              </Route>
              <Route exact path={["/deletedata"]}>
                <DeleteData />
              </Route>
            </Switch>
          </ErrorBoundary>
        </Router>
      </LocaleContextComponent>}
    </>
  );
}

export default App;
